<template>

</template>

<script>
export default {
  name: "approve_merchant"
}
</script>

<style src="../css/approve_merchant.css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/approve_merchant.vue